import Accordion from '@mui/material/Accordion';
import { useMediaQuery } from 'react-responsive';
import { useState } from 'react';
import { List } from '@mui/material';
import EventDayStatusSummary from './EventDayStatusSummary';
import CameraUploadStatus from './CameraUploadStatus';
import { EventUploadDetails } from '../../../model/event-upload-details';

interface IProps {
  eventUploadStatus: EventUploadDetails;
  groupPicturesExpected: boolean;
}

function EventStatusDetail({ eventUploadStatus, groupPicturesExpected }: IProps) {
  const statusDetails = eventUploadStatus?.cameraUploadDetails;

  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 900px)' });
  const [expanded, setExpanded] = useState(!isTabletOrMobile);

  const handleChange = () => {
    setExpanded(!expanded);
  };

  return (
    <>
      <Accordion
        elevation={0}
        disableGutters
        expanded={expanded}
        onChange={handleChange}
      >
        <EventDayStatusSummary
          day={eventUploadStatus?.day}
          pictureDayStatus={eventUploadStatus?.pictureDayStatus}
        />
        <List
          data-testid='event-status'
          sx={{ width: '100%', bgcolor: 'background.paper', p: 0 }}
        >
          {statusDetails?.map((item) => (
            <CameraUploadStatus
              key={'camera_' + item.cameraName}
              cameraStatusDetails={item}
              groupPicturesExpected={groupPicturesExpected}
            />
          ))}
        </List>
      </Accordion>
    </>
  );
}

export default EventStatusDetail;
